export const CLIENT_ID = 'webApp'
export const APPVERSION = 'v1.0.0'
export const USER = 'USER'
export const GENDER: Index = {
  1: '男',
  2: '女',
}
